const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/documents/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllLegalFilesQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/documents/')({
  loader: async ({
    context: {
      queryClient
    }
  }) => {
    queryClient.ensureQueryData(getFindAllLegalFilesQueryOptions());
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});